import React, { useCallback } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import { clearSchoolData } from "../../redux/reducers/schoolReducer";
import * as userActions from "../../redux/reducers/userReducer";
import { userState } from "../../redux/reducers/userReducer";

import { BanknotesIcon, ShoppingCartIcon, TicketIcon } from "@heroicons/react/20/solid";
import { TwMainLayout } from "../../components/tailwind";
import { useToast } from "../../provider/ToastProvider";
import { setGlobalLoading } from "../../redux/reducers/loadingReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForUsers } from "../../utils/confighelpers";
import RecentEventBooking from "../businessProfile/booking/RecentEventBooking";
import UpcomingEventActivites from "../businessProfile/UpcomingEventActivites";
import { useTranslation } from "react-i18next";
import GuestEventBooking from "./GuestEventBooking";

export default function GuestsList({}) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken, setUserToken] = useLocalStorage("userToken");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userReduxState = useSelector(userState);
  const dashboardReduxState = useSelector(dashboardState);
  const [dashboardStatistics, setDashboardStatistics] = React.useState([
    {
      id: 1,
      name: t("bookings.totalBookingTitle"),
      stat: "0",
      icon: ShoppingCartIcon,
      change: "0%",
      changeType: "increase",
    },
    {
      id: 2,
      name: t("myEvents.totalTicketsSold"),
      stat: "0",
      icon: TicketIcon,
      change: "0%",
      changeType: "increase",
    },
    {
      id: 3,
      name: "Total Earning",
      stat: "0",
      icon: BanknotesIcon,
      change: "0%",
      changeType: "increase",
    },
  ]);
  const [dashboardStatisticsResponse, setDashboardStatisticsResponse] =
    React.useState({});
  const [backgroundForHome, setBackgroundForHome] = React.useState(false);
  const [dashboardFilter, setDashboardFilter] = React.useState("today");

  const getUserInfo = async () => {
    const config = {
      method: "get",
      url: `${getUrlForUsers()}getUserInfo`,
      headers: {
        "x-access-token": userToken,
      },
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config).catch(async (e) => {
      console.error("Session Has Expired");
      if (
        e.response &&
        (e.response.status === 401 || e.response.status === 502)
      ) {
        localStorage.removeItem("userToken");
        localStorage.removeItem("persist:root");
        dispatch(userActions.clearUserData());
        dispatch(clearSchoolData());
        dispatch(dashboardActions.clearDashboardData());
        await setUserToken("");
        window.location.href = "/";
      }
    });
    dispatch(setGlobalLoading(false));
    if (request.data.statusCode === 200) {
      const userData = request.data.data;

      dispatch(userActions.setUserData(userData));
      // }
      if (userData.onBoardingStep === 0 || userData.onBoardingStep === false) {
        // no need to handel this otp number screen becouse not registerd yet
        // if (userData.socialType == "normal" && userData.isVerified == false) {
        //   await handleResendSMS(userData, userData.socialType, userData.countryCode, userData.phoneNumber)
        // }
        if (userData.isVerified == true) {
          delete userData._id;
          dispatch(
            userActions.setOnBoardingData({
              ...(userReduxState &&
              userReduxState.onBoardingData &&
              Object.keys(userReduxState.onBoardingData).length > 0
                ? userReduxState.onBoardingData
                : {}),
              ...userData,
              name: userData.fullName,
              sentFromSignupComplete: true,
              from: "list",
            }),
          );
          navigate("/on-bording", {
            /** new on-bording **/
            state: {
              // ...location.state,
              ...userData,
              name: userData.fullName,
              sentFromSignupComplete: true,
              from: "list",
            },
          });
        } else {
          await Logout("");
          // navigate("/");
        }
      } else if (userData.onBoardingStep === 1) {
        setBackgroundForHome(false);
        dispatch(
          userActions.setOnBoardingData({
            ...(userReduxState &&
            userReduxState.onBoardingData &&
            Object.keys(userReduxState.onBoardingData).length > 0
              ? userReduxState.onBoardingData
              : {}),
            ...userData,
            name: userData.fullName,
            sentFromSignupComplete: true,
          }),
        );
        navigate("/on-bording", {
          /** new on-bording **/
          state: {
            ...userData,
            sentFromSignupComplete: true,
            name: userData.fullName,
            // socialType: location.state.socialType,
            // username: location.state.username,
          },
        });
      } else if (userData.onBoardingStep === 2) {
        dispatch(
          userActions.setOnBoardingData({
            ...(userReduxState &&
            userReduxState.onBoardingData &&
            Object.keys(userReduxState.onBoardingData).length > 0
              ? userReduxState.onBoardingData
              : {}),
            ...userData,
            name: userData.fullName,
          }),
        );
        // let nextUrl = "/businessprofilesetup/subscription"
        // let nextUrl = "/businessprofilesetup/done"
        let nextUrl = "/my-subscription"; /** new on-bording **/
        navigate(nextUrl, {
          state: {
            ...userData,
            from: "onbording",
            sentFromVerifyEmail: true,
            address: {},
          },
        });
      } else if (userData.onBoardingStep === 3) {
        setBackgroundForHome(true);
        if (request.data.data?.businessType) {
          if (request.data.data?.businessType !== userReduxState.businessType) {
            await dispatch(
              userActions.setBusinessType(request.data.data?.businessType),
            );
            // window.location.reload();
            setTimeout(() => {
              window.location.href = "/";
            }, 1000);
          }
        } else {
          await dispatch(userActions.setBusinessType("event"));
          // await dispatch(userActions.setBusinessType(""));
          await updateUserProfile();
        }
        //   )
      }
    }
  };

  const Logout = async () => {
    try {
      await axiosInstance.put(
        `${getUrlForUsers()}logoutUser`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "x-access-token": userToken,
          },
        },
      );
    } catch (err) {
    } finally {
      localStorage.removeItem("userToken");
      localStorage.removeItem("persist:root");
      dispatch(userActions.clearUserData());
      dispatch(clearSchoolData());
      dispatch(dashboardActions.clearDashboardData());
      await setUserToken("");
      // navigate("/", { replace: true });
      window.location.href = "/";
    }
  };

  const fetchData = useCallback(async () => {
    // }
    getDashboardStatistics();
    getUserInfo();

    // return () => clearInterval(unsubscribe);
  }, []);

  React.useEffect(() => {
    fetchData();
  }, []);

  const updateUserProfile = async () => {
    const requestConfig = {
      method: "put",
      url: `${getUrlForUsers()}updateProfile`,
      headers: {
        "x-access-token": userToken,
      },
      data: {
        businessType: userReduxState.businessType,
      },
    };
    const response = await axiosInstance(requestConfig);
    if (response.status === 200) {
      if (response.data.statusCode === 403) {
      } else if (response.data.statusCode === 200) {
      }
    }
  };

  const getDashboardStatistics = async () => {
    const config = {
      method: "get",
      url: `${getUrlForUsers()}statistics`,
      headers: {
        "x-access-token": userToken,
      },
    };
    const request = await axiosInstance.request(config);
    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        setDashboardStatisticsResponse(request.data.data);
      }
    }
  };

  if (userToken === undefined || !userToken || userToken.length < 1) {
    // navigate("/", { replace: true });
  }

  //   navigate("/myschedule", { replace: true }); // comment if display Dashboard

  React.useEffect(() => {
    if (dashboardStatisticsResponse[dashboardFilter]) {
      let statistics = dashboardStatisticsResponse[dashboardFilter];

      setDashboardStatistics([
        {
          id: 1,
          name: t("bookings.totalBookingTitle"),
          stat: statistics.totalBookings,
          icon: ShoppingCartIcon,
          change: `${parseFloat(statistics?.bookingChange || 0).toFixed(2)}%`,
          changeType:
            parseFloat(statistics.bookingChange) > 0 ? "increase" : "decrease",
        },
        {
          id: 2,
          name: t("myEvents.totalTicketsSold"),
          stat: statistics.totalTickets,
          icon: TicketIcon,
          change: `${parseFloat(statistics?.ticketChange || 0).toFixed(2)}%`,
          changeType:
            parseFloat(statistics.ticketChange) > 0 ? "increase" : "decrease",
        },
        {
          id: 3,
          name: "Total Earning",
          stat: parseFloat(statistics.totalEarnings).toFixed(2),
          icon: BanknotesIcon,
          change: `${parseFloat(statistics?.earningChange || 0).toFixed(2)}%`,
          changeType:
            statistics.earningChange && parseFloat(statistics.earningChange) > 0
              ? "increase"
              : "decrease",
        },
      ]);
    }

    // }, [dashboardStatisticsResponse]);
  }, [dashboardFilter, dashboardStatisticsResponse]);

  return (
    <TwMainLayout
      headTitle={t("pageTitle.myGuest")}
      navBarTitleComp={
        <h3 className={"font-extrabold text-2xl text-primary"}>Dashboard</h3>
      }
      children={
        <div className="flex flex-col gap-3 p-5">
          <div className={`flex flex-col gap-6`}>
            {userReduxState.businessType === "event" ? (
              <GuestEventBooking bookingType="teacherRecentBookings" />
            ) : (
              ""
            )}
          </div>
        </div>
      }
    />
  );
}
